import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import CloneButton from '../../buttons/CloneButton';

const ArchivedStatusActions = ({ itemId }) => (
  <Fragment>
    <CloneButton itemId={itemId} />
  </Fragment>
);

ArchivedStatusActions.propTypes = {
  itemId: PropTypes.number.isRequired,
};

export default ArchivedStatusActions;
